document.addEventListener("DOMContentLoaded", () => {

  var path = window.location.pathname.replace(/\/$/, "");

  // Main page
  if (path === "/pages/shop-by-boat") {
    var mainSection = document.getElementById("shopify-section-template--26951919599906__shop_by_boat_filter_NbKGgU");
    if (mainSection) {
      mainSection.style.display = "none";
    }
  }

  // Sub pages
  if (
    path === "/pages/sailboats" ||
    path === "/pages/sportfish" ||
    path === "/pages/center-consoles" ||
    path === "/pages/cruisers-yachts" ||
    path === "/pages/professional-crew"
  ) {
    var subSections = document.querySelectorAll(".home-how-you-boat-section, .home-how-you-boat-grid-section");
    subSections.forEach(function (el) {
      el.style.display = "none";
    });

    var elementsToHide = document.querySelectorAll(
      ".shop-by-boat__heading, .shop-by-boat__filters, .shop-by-boat__results-bar"
    );

    elementsToHide.forEach(function (el) {
      el.style.display = "none";
    });
  }

//Replacing Safety Data Sheets URL
function updateSafetyDataSheetLinks() {
  document.querySelectorAll('a.featured-blog-posts-card__link').forEach(function (link) {
    if (link.getAttribute('href') === '/blogs/news/safety-data-sheets-sds-msds') {
      link.setAttribute('href', '/pages/safety-data-sheets-sds-msds');
    }
  });
}

updateSafetyDataSheetLinks();

const observer = new MutationObserver(updateSafetyDataSheetLinks);

observer.observe(document.body, {
  childList: true,
  subtree: true
});
//Replacing Safety Data Sheets URL Ends

var swiper_how_you_boat = new Swiper(".how-you-boat-swiper", {
    spaceBetween: 15,
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    autoplay: {
    delay: 4500,
    disableOnInteraction: true,
    },
    breakpoints: {
    640: {
        slidesPerView: 1,
    },
    768: {
        slidesPerView: 1,
    },
    1024: {
        slidesPerView: 3.4,
        spaceBetween: 15,
    },
    },
    pagination: {
    el: ".swiper-pagination",
    clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
});

var swiper_built_for_home = new Swiper(".home-built-for-every-swiper", {
    spaceBetween: 15,
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    autoplay: {
    delay: 4500,
    disableOnInteraction: true,
    },
    breakpoints: {
    640: {
        slidesPerView: 1,
    },
    768: {
        slidesPerView: 1,
    },
    1024: {
        slidesPerView: 1,
        spaceBetween: 15,
    },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
});

var swiper_home_testimonials = new Swiper(".home-testimonial-swiper", {
    spaceBetween: 15,
    slidesPerView: 1,
    loop: true,
    autoplay: {
    delay: 4500,
    disableOnInteraction: true,
    },
    breakpoints: {
    640: {
        slidesPerView: 1,
    },
    768: {
        slidesPerView: 1,
    },
    1024: {
        slidesPerView: 3,
        spaceBetween: 15,
    },
    },
    pagination: {
    el: ".swiper-pagination",
    clickable: true,
    },
});

//////Triple vertical product JS start
 function initSection(sectionEl) {
    if (!sectionEl) return;

    const swiperEls = Array.from(
      sectionEl.querySelectorAll(".triple-vps__swiper")
    );
    if (!swiperEls.length) return;

    if (typeof window.Swiper === "undefined") {
      const msg = sectionEl.querySelector("[data-triple-vps-msg]");
      if (msg) msg.textContent = "Swiper library not loaded.";
      return;
    }

    const instances = swiperEls.map((swiperEl) => {
      const up = swiperEl.querySelector(".triple-vps__btn--up");
      const down = swiperEl.querySelector(".triple-vps__btn--down");

      const inst = new Swiper(swiperEl, {
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        mousewheel: {
          forceToAxis: true,
        },
      });

      if (up) up.addEventListener("click", () => inst.slidePrev());
      if (down) down.addEventListener("click", () => inst.slideNext());

      return inst;
    });

    const addBtn = sectionEl.querySelector("[data-triple-vps-add]");
    const msg = sectionEl.querySelector("[data-triple-vps-msg]");

    async function addAllToCart() {
      if (!addBtn) return;

      addBtn.disabled = true;
      if (msg) msg.textContent = "Adding to cart…";

      try {
        const items = instances
          .map((inst) => {
            const activeSlide = inst.slides[inst.activeIndex];
            if (!activeSlide) return null;

            const variantId = activeSlide.getAttribute("data-variant-id");
            if (!variantId) return null;

            return {
              id: Number(variantId),
              quantity: 1,
            };
          })
          .filter(Boolean);

        if (items.length !== 3) {
          throw new Error(
            "Please ensure all 3 carousels have a selected product."
          );
        }

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items }),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(
            err?.description || "Could not add products to cart."
          );
        }

        const redirect =
          addBtn.getAttribute("data-success-redirect") || "cart";

        if (msg) msg.textContent = "Added to cart!";

        if (redirect === "cart") {
          window.location.href = "/cart";
        } else if (redirect === "checkout") {
          window.location.href = "/checkout";
        } else {
          addBtn.disabled = false;
        }
      } catch (e) {
        if (msg) msg.textContent = e.message || "Something went wrong.";
        addBtn.disabled = false;
      }
    }

    if (addBtn) addBtn.addEventListener("click", addAllToCart);
  }

  /* ---------- Init on page load ---------- */
  document
    .querySelectorAll("[data-triple-vps-section]")
    .forEach(initSection);

  /* ---------- Support Shopify Theme Editor ---------- */
  document.addEventListener("shopify:section:load", (e) => {
    const sectionEl =
      e.target?.matches?.("[data-triple-vps-section]")
        ? e.target
        : e.target?.querySelector?.("[data-triple-vps-section]");

    if (sectionEl) initSection(sectionEl);
  });
//////Triple vertical product JS ends


//////Gloss System Builder Start
  document.querySelectorAll("[data-gsb-section]").forEach(initGlossSystemBuilder);

  document.addEventListener("shopify:section:load", (e) => {
    const el =
      e.target?.querySelector?.("[data-gsb-section]") ||
      (e.target?.matches?.("[data-gsb-section]") ? e.target : null);
    if (el) initGlossSystemBuilder(el);
  });

  function initGlossSystemBuilder(root) {
    if (!root || root.__gsbInited) return;
    root.__gsbInited = true;

    const moneyFormat = safeJsonParse(root.getAttribute("data-money-format")) || "${{amount}}";

    const state = {
      restore: [],
      protect: [],
      clean: [],
    };

    const stepsOrder = ["restore", "protect", "clean"];

    ////
    

      // --- Smooth accordion open/close (height animation) ---
      const stepDetailsEls = Array.from(root.querySelectorAll(".gsb__step"));

      function setContentHeight(detailsEl, toOpen) {
        const content = detailsEl.querySelector("[data-gsb-step-content]");
        if (!content) return;

        // Measure inner body
        const inner = content.firstElementChild; // .gsb__step-body
        if (!inner) return;

        // If opening: set from 0 -> scrollHeight
        if (toOpen) {
          // Start from current height (usually 0)
          content.style.height = content.getBoundingClientRect().height + "px";

          // Force layout
          content.offsetHeight;

          // Animate to full height
          const target = inner.scrollHeight;
          content.style.height = target + "px";

          // After animation, set to 'auto' so content can grow (e.g., font changes)
          const onEnd = () => {
            content.style.height = "auto";
            content.removeEventListener("transitionend", onEnd);
          };
          content.addEventListener("transitionend", onEnd);
        } else {
          // Closing: from current height (auto -> px) -> 0
          // If currently auto, convert to px first
          const current = inner.scrollHeight;
          content.style.height = current + "px";

          // Force layout
          content.offsetHeight;

          // Animate to 0
          content.style.height = "0px";
        }
      }

      // Initialize current open state on load
      stepDetailsEls.forEach((d) => {
        const content = d.querySelector("[data-gsb-step-content]");
        if (!content) return;
        if (d.open) content.style.height = "auto";
        else content.style.height = "0px";
      });

      // Single-open + smooth animation combined
      stepDetailsEls.forEach((detailsEl) => {
        detailsEl.addEventListener("toggle", () => {
          // Opening
          if (detailsEl.open) {
            // Close others (and animate them closed)
            stepDetailsEls.forEach((other) => {
              if (other !== detailsEl && other.open) {
                setContentHeight(other, false);
                other.open = false;
              }
            });

            // Animate this one open
            setContentHeight(detailsEl, true);
            
            // 🔽 Smooth scroll to top of this step
            setTimeout(() => {
              const offset = 120; // adjust for sticky header height
              const top =
                detailsEl.getBoundingClientRect().top +
                window.pageYOffset -
                offset;

              window.scrollTo({
                top: top,
                behavior: "smooth",
              });
            }, 50); // small delay so height animation begins first
          } else {
            // Animate this one closed
            setContentHeight(detailsEl, false);
          }
        });
      });

    ////

    const stepMetaEls = {
      restore: root.querySelector('[data-gsb-step-meta="restore"]'),
      protect: root.querySelector('[data-gsb-step-meta="protect"]'),
      clean: root.querySelector('[data-gsb-step-meta="clean"]'),
    };

    const summaryItemsRoot = root.querySelector("[data-gsb-summary-items]");
    const summaryEmpty = root.querySelector("[data-gsb-summary-empty]");
    const totalEl = root.querySelector("[data-gsb-total]");
    const addBtn = root.querySelector("[data-gsb-add]");
    const msgEl = root.querySelector("[data-gsb-msg]");

    // ---- Variant selection (only sets active variant + updates card price) ----
    root.querySelectorAll("[data-gsb-variant]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const productEl = btn.closest("[data-gsb-product]");
        if (!productEl) return;

        const available = btn.getAttribute("data-variant-available") === "true";
        if (!available || btn.disabled) {
          // auto-switch to next available variant
          const picked = pickFirstAvailableVariant(productEl);
          if (!picked) return;
          setActiveVariantButton(productEl, picked.btn);
          updateCardPrice(productEl, picked.priceCents);
          return;
        }

        setActiveVariantButton(productEl, btn);

        const priceCents = Number(btn.getAttribute("data-variant-price-cents") || "0");
        updateCardPrice(productEl, priceCents);
      });
    });

    // ---- Select button (THIS triggers selection into system) ----
    root.querySelectorAll("[data-gsb-select]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const productEl = btn.closest("[data-gsb-product]");
        if (!productEl) return;

        const step = btn.getAttribute("data-step");
        if (!step) return;

        const picked = pickVariantForProduct(productEl);
        if (!picked) return;

        setSelection(step, productEl, picked.variantId, picked.variantTitle, picked.priceCents);
      });
    });

    // ---- Skip buttons (skip closes current and opens next) ----
    root.querySelectorAll("[data-gsb-skip]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const step = btn.getAttribute("data-gsb-skip");
        if (!step) return;

        clearSelection(step);
        advanceAccordion(step);
      });
    });

    // ---- Add to cart ----
    if (addBtn) {
      addBtn.addEventListener("click", async () => {
        addBtn.disabled = true;
        if (msgEl) msgEl.textContent = "Adding system to cart…";

        try {
          const items = stepsOrder
          .flatMap((step) => state[step])
          .map((item) => ({
            id: item.variantId,
            quantity: item.qty,
          }));

          if (!items.length) {
            throw new Error("Please select at least one product before adding to cart.");
          }

          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items }),
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err?.description || "Could not add items to cart.");
          }

          if (msgEl) msgEl.textContent = "Added! Redirecting to cart…";
          window.location.href = "/cart";
        } catch (err) {
          if (msgEl) msgEl.textContent = err.message || "Something went wrong.";
          addBtn.disabled = false;
        }
      });
    }

    // ---- Initial meta ----
    stepsOrder.forEach((s) => renderStepMeta(s));
    renderSummaryAndTotal();

    // ---------------- Helpers ----------------

    function findSelection(step, productKey) {
      return state[step].find((item) => item.productKey === productKey);
    }

    function removeSelection(step, productKey) {
      state[step] = state[step].filter((item) => item.productKey !== productKey);

      const productEl = root.querySelector(
        `.gsb__product[data-step="${CSS.escape(step)}"][data-product-handle="${CSS.escape(productKey)}"]`
      );

      if (productEl) {
        productEl.classList.remove("is-selected");

        const btn = productEl.querySelector("[data-gsb-select]");
        if (btn) resetSelectButton(btn, productEl.getAttribute("data-step-index"));
      }

      renderStepMeta(step);
      renderSummaryAndTotal();
    }

    function updateCardPrice(productEl, priceCents) {
      const priceEl = productEl.querySelector("[data-gsb-product-price]");
      if (!priceEl) return;
      priceEl.textContent = formatMoney(priceCents, moneyFormat);
    }

    function pickVariantForProduct(productEl) {
      // Prefer active & available, otherwise first available
      const activeBtn = productEl.querySelector(".gsb__variant-btn.is-active");
      if (activeBtn) {
        const available = activeBtn.getAttribute("data-variant-available") === "true";
        if (available && !activeBtn.disabled) {
          return {
            variantId: Number(activeBtn.getAttribute("data-variant-id")),
            variantTitle: activeBtn.getAttribute("data-variant-title") || "Default",
            priceCents: Number(activeBtn.getAttribute("data-variant-price-cents") || "0"),
          };
        }
      }
      const picked = pickFirstAvailableVariant(productEl);
      if (!picked) return null;
      setActiveVariantButton(productEl, picked.btn);
      updateCardPrice(productEl, picked.priceCents);
      return {
        variantId: picked.variantId,
        variantTitle: picked.variantTitle,
        priceCents: picked.priceCents,
      };
    }

    function pickFirstAvailableVariant(productEl) {
      const btns = Array.from(productEl.querySelectorAll("[data-gsb-variant]"));
      const first = btns.find((b) => b.getAttribute("data-variant-available") === "true" && !b.disabled);
      if (!first) return null;

      return {
        btn: first,
        variantId: Number(first.getAttribute("data-variant-id")),
        variantTitle: first.getAttribute("data-variant-title") || "Default",
        priceCents: Number(first.getAttribute("data-variant-price-cents") || "0"),
      };
    }

    function setActiveVariantButton(productEl, btn) {
      productEl.querySelectorAll(".gsb__variant-btn").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
    }

    function setSelection(step, productEl, variantId, variantTitle, priceCents) {
      const chosenBtn = productEl.querySelector(`[data-gsb-variant][data-variant-id="${variantId}"]`);

      if (chosenBtn) {
        const available = chosenBtn.getAttribute("data-variant-available") === "true";

        if (!available || chosenBtn.disabled) {
          const picked = pickFirstAvailableVariant(productEl);
          if (!picked) return;

          variantId = picked.variantId;
          variantTitle = picked.variantTitle;
          priceCents = picked.priceCents;

          setActiveVariantButton(productEl, picked.btn);
          updateCardPrice(productEl, priceCents);
        } else {
          setActiveVariantButton(productEl, chosenBtn);
          priceCents = Number(chosenBtn.getAttribute("data-variant-price-cents") || "0");
          updateCardPrice(productEl, priceCents);
        }
      }

      const stepIndex = Number(productEl.getAttribute("data-step-index") || "1");
      const productKey = productEl.getAttribute("data-product-handle") || String(variantId);

      const existingIndex = state[step].findIndex((item) => item.productKey === productKey);

      const itemData = {
        productKey,
        variantId,
        variantTitle,
        productTitle: productEl.getAttribute("data-product-title") || "Product",
        image: productEl.getAttribute("data-product-image") || "",
        url: productEl.getAttribute("data-product-url") || "#",
        qty: existingIndex > -1 ? state[step][existingIndex].qty : 1,
        priceCents: priceCents || 0,
        stepIndex,
        stepName: step,
      };

      if (existingIndex > -1) {
        state[step][existingIndex] = itemData;
      } else {
        state[step].push(itemData);
      }

      productEl.classList.add("is-selected");

      const selectBtn = productEl.querySelector("[data-gsb-select]");
      if (selectBtn) setSelectedButtonText(selectBtn, stepIndex);

      renderStepMeta(step);
      renderSummaryAndTotal();

      // Important: do NOT call advanceAccordion(step) here anymore.
    }

    function clearSelection(step) {
      state[step] = [];

      root.querySelectorAll(`.gsb__product[data-step="${step}"]`).forEach((p) => {
        p.classList.remove("is-selected");

        const b = p.querySelector("[data-gsb-select]");
        if (b) resetSelectButton(b, p.getAttribute("data-step-index"));
      });

      renderStepMeta(step);
      renderSummaryAndTotal();
    }

    function renderStepMeta(step) {
      const el = stepMetaEls[step];
      if (!el) return;

      const count = state[step].length;

      el.textContent = count > 0
        ? `${count} Selected`
        : "Choose 1 or Skip";
    }

    function renderSummaryAndTotal() {
      if (!summaryItemsRoot) return;

      summaryItemsRoot.innerHTML = "";
      let any = false;

      stepsOrder.forEach((step) => {
        const items = state[step];
        if (!items.length) return;

        const stepTitle = getStepTitle(step);

        let formattedTitle;
        switch (stepTitle) {
          case "Step 1 – Restore":
            formattedTitle = "Restore";
            break;
          case "Step 2 – Protect":
            formattedTitle = "Protect";
            break;
          case "Step 3 – Clean":
            formattedTitle = "Clean";
            break;
          default:
            formattedTitle = stepTitle;
        }

        items.forEach((s) => {
          any = true;

          const linePrice = (s.priceCents || 0) * (s.qty || 1);

          const block = document.createElement("div");
          block.className = "gsb__summary-step-block";
          block.innerHTML = `
            <button
              type="button"
              class="gsb__remove"
              aria-label="Remove ${escapeHtml(s.productTitle)}"
              data-gsb-remove-step="${escapeHtml(step)}"
              data-gsb-remove-key="${escapeHtml(s.productKey)}"
            >×</button>

            <div class="gsb__selected">
              ${s.image ? `<img src="${escapeHtml(s.image)}" alt="${escapeHtml(s.productTitle)}">` : ""}
              <div>
                <div class="gsb__summary-step-name ${escapeHtml(formattedTitle).toLowerCase()}">
                  ${escapeHtml(formattedTitle)}
                </div>

                <div class="gsb__selected-title">
                  <a href="${escapeHtml(s.url)}">${escapeHtml(s.productTitle)}</a>
                </div>

                <div class="gsb__selected-variant">${escapeHtml(s.variantTitle)}</div>

                <div class="gsb__qty" data-gsb-qty-step="${escapeHtml(step)}" data-gsb-qty-key="${escapeHtml(s.productKey)}">
                  <button type="button" class="gsb__qty-btn" data-gsb-qty-minus aria-label="Decrease quantity">−</button>
                  <span class="gsb__qty-num" data-gsb-qty-num>${s.qty}</span>
                  <button type="button" class="gsb__qty-btn" data-gsb-qty-plus aria-label="Increase quantity">+</button>
                </div>

                <div class="gsb__line-price" data-gsb-line-price>
                  ${formatMoney(linePrice, moneyFormat)}
                </div>
              </div>
            </div>
          `;

          summaryItemsRoot.appendChild(block);

          const removeBtn = block.querySelector("[data-gsb-remove-key]");
          if (removeBtn) {
            removeBtn.addEventListener("click", () => {
              removeSelection(step, s.productKey);
            });
          }

          const numEl = block.querySelector("[data-gsb-qty-num]");
          const minus = block.querySelector("[data-gsb-qty-minus]");
          const plus = block.querySelector("[data-gsb-qty-plus]");
          const lineEl = block.querySelector("[data-gsb-line-price]");

          if (minus) {
            minus.addEventListener("click", () => {
              const item = findSelection(step, s.productKey);
              if (!item) return;

              item.qty = Math.max(1, (item.qty || 1) - 1);
              if (numEl) numEl.textContent = String(item.qty);

              const newLine = (item.priceCents || 0) * item.qty;
              if (lineEl) lineEl.textContent = formatMoney(newLine, moneyFormat);

              updateTotal();
            });
          }

          if (plus) {
            plus.addEventListener("click", () => {
              const item = findSelection(step, s.productKey);
              if (!item) return;

              item.qty = Math.min(99, (item.qty || 1) + 1);
              if (numEl) numEl.textContent = String(item.qty);

              const newLine = (item.priceCents || 0) * item.qty;
              if (lineEl) lineEl.textContent = formatMoney(newLine, moneyFormat);

              updateTotal();
            });
          }
        });
      });

      if (!any) {
        const empty = document.createElement("div");
        empty.className = "gsb__summary-placeholder";
        empty.textContent = "No selections yet.";
        summaryItemsRoot.appendChild(empty);
      }

      updateTotal();
    }

    function updateTotal() {
      const totalCents = stepsOrder.reduce((sum, step) => {
        return sum + state[step].reduce((stepSum, item) => {
          return stepSum + (item.priceCents || 0) * (item.qty || 1);
        }, 0);
      }, 0);

      if (totalEl) totalEl.textContent = formatMoney(totalCents, moneyFormat);
    }

    function advanceAccordion(currentStep) {
      const currentIndex = stepsOrder.indexOf(currentStep);
      const nextStep = stepsOrder[currentIndex + 1];
      const currentDetails = root.querySelector(`details[data-step="${CSS.escape(currentStep)}"]`);
      if (currentDetails) currentDetails.open = false;

      if (nextStep) {
        const nextDetails = root.querySelector(`details[data-step="${CSS.escape(nextStep)}"]`);
        if (nextDetails) nextDetails.open = true;
      }
    }

    function openStep(step) {
      const details = root.querySelector(`details[data-step="${CSS.escape(step)}"]`);
      if (!details) return;
      details.open = true;
      details.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function getStepTitle(step) {
      const details = root.querySelector(`details[data-step="${CSS.escape(step)}"]`);
      const title = details?.querySelector(".gsb__step-title")?.textContent?.trim();
      return title || step;
    }

    function resetSelectButton(btn, stepIndex) {
      btn.classList.remove("is-selected");
      btn.innerHTML = escapeHtml(root.querySelector("[data-gsb-section]")?.__selectLabel || "") || btn.textContent;
      // We’ll re-derive label from initial HTML if needed
      // If you want perfect reset label, keep it stored:
      // handled below in init
      btn.textContent = root.__selectLabel || "Select for My System";
    }

    function setSelectedButtonText(btn, stepIndex) {
      btn.classList.add("is-selected");
      btn.innerHTML = `✓ Selected for Step ${stepIndex}`;
    }

    function safeJsonParse(str) {
      try { return JSON.parse(str); } catch { return null; }
    }

    function formatMoney(cents, fmt) {
      // Prefer Shopify.formatMoney if available
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents, fmt);
      }
      // Basic fallback
      const value = (cents / 100).toFixed(2);
      // Try to mimic common formats
      if (typeof fmt === "string" && fmt.includes("{{amount}}")) {
        return fmt.replace("{{amount}}", value);
      }
      return "$" + value;
    }

    function escapeHtml(str) {
      return String(str)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    }

    // Store initial select label (for proper resets)
    root.__selectLabel = root.querySelector(".gsb__select")?.textContent?.trim() || "Select for My System";
  }
//////Gloss System Builder End


//Steps - Gloss system 'active' class logic
const sections = document.querySelectorAll(".trfg");

  sections.forEach((section) => {
    const cards = section.querySelectorAll(".trfg__card--bottom");
    if (cards.length < 4) return;

    let currentIndex = 0;
    const delay = 2500; // 2.5 seconds between each activation

    function resetAll() {
      cards.forEach((card) => card.classList.remove("active"));
    }

    function runLoop() {
      resetAll();
      currentIndex = 0;

      const interval = setInterval(() => {
        if (currentIndex < cards.length) {
          cards[currentIndex].classList.add("active");
          currentIndex++;
        } else {
          clearInterval(interval);

          // After last one stays active for delay, restart
          setTimeout(() => {
            runLoop();
          }, delay);
        }
      }, delay);
    }

    runLoop();
  });
  //Steps - Gloss system 'active' class logic ends

  //Popup code
  const modal = document.getElementById('gsbLearnMoreModal');
  if (!modal) return;

  const titleEl = modal.querySelector('.gsb-modal__title');
  const descEl = modal.querySelector('.gsb-modal__desc');
  const tagsEl = modal.querySelector('.gsb-modal__tags');
  const productLinkEl = modal.querySelector('.gsb-modal__product-link');

  let lastFocusedEl = null;

  function openModal() {
    lastFocusedEl = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    // focus close button for accessibility
    const closeBtn = modal.querySelector('[data-gsb-modal-close]');
    if (closeBtn) closeBtn.focus();

    document.documentElement.classList.add('gsb-modal-open');
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gsb-modal-open');

    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
      lastFocusedEl.focus();
    }
  }

  function setModalContentFromProduct(productEl) {
  const title = productEl.querySelector('.gsb__product-title')?.textContent?.trim() || '';
  const desc = productEl.querySelector('.gsb__product-desc')?.innerHTML || '';
  const tagsContainer = productEl.querySelector('.gsb__product-tags');
  const productUrl =
    productEl.getAttribute('data-product-url') ||
    productEl.querySelector('.gsb__learn')?.getAttribute('href') ||
    '#';

  titleEl.textContent = title;
  descEl.innerHTML = desc;

  // Build tags
  tagsEl.innerHTML = '';
  if (tagsContainer) {
    const tags = Array.from(tagsContainer.querySelectorAll('.gsb__tag'))
      .map((t) => t.textContent.trim())
      .filter(Boolean);

    tags.forEach((t) => {
      const span = document.createElement('span');
      span.className = 'gsb-modal__tag';
      span.textContent = t;
      tagsEl.appendChild(span);
    });
  }

  // Accordion content:
  // OPTION A: Read from data attributes on the product card
  // e.g. data-features="..." data-directions="..." data-safety="..."
  //const features = productEl.getAttribute('data-features') || '';
  const directions = productEl.getAttribute('data-right-content') || '';
  //const safety = productEl.getAttribute('data-safety') || '';

  // If you prefer pulling from hidden DOM nodes inside the card instead,
  // we can do that too — but data attributes are simplest.

  //const featuresEl = modal.querySelector('[data-gsb-acc-content="features"]');
  const directionsEl = modal.querySelector('[data-gsb-acc-content="directions"]');
  //const safetyEl = modal.querySelector('[data-gsb-acc-content="safety"]');

  // Allow simple HTML in these strings if you want (lists, line breaks).
  // If you want plain text only, replace innerHTML with textContent.
  //featuresEl.innerHTML = features ? features : '<p class="gsb-acc__empty">No features listed.</p>';
  directionsEl.innerHTML = directions ? directions : '<p class="gsb-acc__empty">No directions listed.</p>';
  //safetyEl.innerHTML = safety ? safety : '<p class="gsb-acc__empty">No safety info listed.</p>';

  // Reset accordion state each time the modal opens
  const allDetails = modal.querySelectorAll('.gsb-acc');
  allDetails.forEach((d, i) => (d.open = i === 0)); // first open, others closed

  //productLinkEl.setAttribute('href', productUrl);
}

  // Event delegation for all current/future .gsb__learn links
  document.addEventListener('click', function (e) {
    const learnLink = e.target.closest('.gsb__learn');
    if (!learnLink) return;

    // Only handle if inside a product card like your snippet
    const productEl = learnLink.closest('.gsb__product');
    if (!productEl) return;

    e.preventDefault();

    setModalContentFromProduct(productEl);
    openModal();
  });

  // Close handlers (overlay + close button)
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-gsb-modal-close]')) {
      closeModal();
    }
  });

  // ESC to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
  //Popup code end


  //Shop by boat type code start
  
  //Shop by boat type code end


});


